import React from "react";

export default function MapLink({ latitude, longitude }) {
  let link = `https://www.google.es/maps?q=${latitude},${longitude}`;

  return (
    <a href={link} target="blank">
      Ver en gmaps
    </a>
  );
}
